<h2 mat-dialog-title>Contract details</h2>
<button mat-icon-button class="close-button" (click)="onClose()">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <!-- Section 1: Details -->
  <div class="section">
    <div class="section-details">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>IATA Code</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="data.iataCode || ' '"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Valid Since</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="
            data.validSince ? (data.validSince | date : 'dd.MM.yyyy') : ' '
          "
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Valid Until</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="
            data.validUntil ? (data.validUntil | date : 'dd.MM.yyyy') : ' '
          "
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Airport Name</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="data.airportName || ' '"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Service Type</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="data.serviceType || ' '"
        />
      </mat-form-field>
    </div>
    <div class="section-details contract-fields">
      <mat-form-field appearance="outline" class="form-field contract-id-field">
        <mat-label>Contract ID</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="' '"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Contract Amount</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="
            data.contractedAmount ? (data.contractedAmount | number) : '0'
          "
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field narrow-field">
        <mat-label>Unit</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="contractedAmountUnit || 'T'"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Contract Value</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="data.contractedValue ? (data.contractedValue | number) : '0'"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field narrow-field">
        <mat-label>Currency</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="contractedValueCurrency || 'USD'"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Payment terms</mat-label>
        <input 
          matInput 
          class="disabled"
          readonly
          [value]="paymentTerms">
      </mat-form-field>
    </div>
  </div>

  <div class="section">
    <div class="supplier-itp-grid">
      <div>
        <div class="section-header">Fuel Supplier</div>
        <div class="details-grid">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Fuel Supplier</mat-label>
            <input
              matInput
              class="disabled"
              readonly
              [value]="data.fuelSupplier || ' '"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>SAP ID</mat-label>
            <input
              matInput
              class="disabled"
              readonly
              [value]="
                fuelSupplierContacts[0]
                  ? fuelSupplierContacts[0].sapId
                  : ' '
              "
            />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Station Manager</mat-label>
            <input
              matInput
              class="disabled"
              readonly
              [value]="
                accountManagerContacts[0]
                  ? accountManagerContacts[0].stationManager
                  : ''
              "
            />
          </mat-form-field>
        </div>
        <table class="table table fuel-supplier-table">
          <thead>
            <tr>
              <th>Media No</th>
              <th>Media Type</th>
              <th>Contact Type</th>
              <th>Contact</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let contact of accountManagerContacts; let i = index">
              <td class="disabled">{{ contact.contactMediaNo }}</td>
              <td class="disabled">{{ contact.contactMediaType }}</td>
              <td class="disabled">{{ contact.contactType }}</td>
              <td class="disabled">{{ contact.contactDetails }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Separator -->
      <div class="separator"></div>

      <!-- ITP Agent -->
      <div>
        <div class="section-header">ITP Agent</div>
        <div>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Name</mat-label>
            <input
              matInput
              class="disabled"
              readonly
              [value]="data.itpAgent || ''"
            />
          </mat-form-field>
        </div>

        <table class="table">
          <thead>
            <tr>
              <th>Media No</th>
              <th>Media Type</th>
              <th>Contact</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let contact of itpAgentContacts">
              <td class="disabled">{{ contact.mediaNo ?? "" }}</td>
              <td class="disabled">{{ contact.mediaType || "" }}</td>
              <td class="disabled">{{ contact.contact || "" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Separator -->
      <div class="separator"></div>
    </div>
  </div>

  <!-- Section 3: Price Details -->
  <div class="section">
    <div class="section-header">Price Details</div>
    <div class="section-details price-details-fields">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>
          Index Name
          {{ data.fuelPriceIndexId ? '(Platts)' : data.papIndexId ? '(PAP)' : '(Platts / PAP)' }}
        </mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="data.fuelPriceIndexId ? fuelPriceIndexName : data.papIndexId ? papIndexName : 'N/A'"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Index Type</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="fuelPriceIndexTypeName"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>SAP Symbol</mat-label>
        <input
          matInput
          class="disabled"
          readonly
          [value]="sapSymbolValue"
        />
      </mat-form-field>
      <div>
        <mat-label class="fees-validity-period-label">Latest Validity Period - Fees</mat-label>
        <div class="fees-validity-period-fields">
          <mat-form-field appearance="outline" class="form-field">
          <mat-label>Valid Since</mat-label>
          <input
            matInput
            class="disabled"
            readonly
            [value]="data.feesLatestValidityPeriodValidSince ? (data.feesLatestValidityPeriodValidSince | date : 'dd.MM.yyyy') : ' '"/>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Valid Until</mat-label>
            <input
              matInput
              class="disabled"
              readonly
              [value]="data.feesLatestValidityPeriodValidUntil ? (data.feesLatestValidityPeriodValidUntil | date : 'dd.MM.yyyy') : ' '"/>
          </mat-form-field>
        </div>
        
      </div>
    </div>

    <!-- Table 1: Index & Differential -->
    <div class="section">
      <table class="table additional-fees-table">
        <thead>
          <tr>
            <th>Fuel Fee</th>
            <th>Value</th>
            <th>Fee UoM</th>
            <th>USD/T</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Index Value</td>
            <td>{{ getIndexValue() | smartNumber }}</td>
            <td>{{ getIndexValueUom() }}</td>
            <td>{{ data.indexValueUsdT }}</td>
          </tr>
          <tr>
            <td>Differential</td>
            <td>{{ data.differential | smartNumber }}</td>
            <td>{{ differentialCurrency && differentialUnit ? (differentialCurrency + '/' + differentialUnit) : (differentialCurrency || differentialUnit || '') }}</td>
            <td>{{ data.differentialUsdT | smartNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Table 2: Service Fees -->
    <div class="section">
      <table class="table additional-fees-table">
        <thead>
          <tr>
            <th>Service Fee</th>
            <th>Value</th>
            <th>Fee Currency</th>
            <th>USD</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Hook Up Fee</td>
            <td>{{ data.hookUpFee | smartNumber }}</td>
            <td>{{ hookUpFeeCurrency }}</td>
            <td>{{ data.hookUpFeeUsdT | smartNumber }}</td>
          </tr>
          <tr>
            <td>&lt;1000 LTR</td>
            <td>{{ data.lessThan1000Ltr | smartNumber }}</td>
            <td>{{ lessThan1000LtrCurrency }}</td>
            <td>{{ data.lessThan1000LtrUsdT | smartNumber }}</td>
          </tr>
          <tr>
            <td>No Fuel</td>
            <td>{{ data.noFuel | smartNumber }}</td>
            <td>{{ noFuelCurrency }}</td>
            <td>{{ data.noFuelUsdT | smartNumber }}</td>
          </tr>
          <tr>
            <td>Out of hours</td>
            <td>{{ data.outOfHours | smartNumber }}</td>
            <td>{{ outOfHoursCurrency }}</td>
            <td>{{ data.outOfHoursUsdT | smartNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Section 4: Contracted SAF Blend -->
    <div class="section contracted-saf-blend-section">
      <div class="section-header saf-blend-header">
        <span class="header-label">
          Contracted SAF Blend
          <span
            class="info-icon"
            matTooltip="Checkbox indicates whether SAF should be a separate item in the SAP export file or not. The numerical value is an indicator of the SAF content in the fuel contracted at a given airport."
          >
            <mat-icon>info_outline</mat-icon>
          </span>
        </span>
      </div>

      <div class="details-grid-saf">
        <mat-checkbox
          class="disabled"
          [disabled]="true"
          [checked]="data.safBlendCheckbox || false"
        ></mat-checkbox>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Percentage Value</mat-label>
          <input
            matInput
            class="disabled"
            [disabled]="true"
            [value]="(data.safBlendPercentage || 0) + ' %'"
            readonly
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>SAF Index</mat-label>
          <input
            matInput
            class="disabled"
            [disabled]="true"
            readonly
            [value]="safIndexName || ' '"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>SAF Index Value</mat-label>
          <input
            matInput
            class="disabled"
            [disabled]="true"
            readonly
            [value]="safIndexValue || 0"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <mat-label>UoM</mat-label>
          <input
            matInput
            class="disabled"
            [disabled]="true"
            readonly
            [value]="safIndexValueCurrency && safIndexValueUnit ? (safIndexValueCurrency + '/' + safIndexValueUnit) : (safIndexValueCurrency || safIndexValueUnit || '')"
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Section 4: Additional Fees -->
  <div class="section contracted-saf-blend-section">
    <div class="section">
      <div class="section-header">Additional Fees</div>
      <table class="table additional-fees-table">
        <thead>
          <tr>
            <th>Fuel Fee</th>
            <th>Value</th>
            <th>Fee UoM</th>
            <th>USD/T</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fee of additionalFees">
            <td>{{ fee.fuelFeeName }}</td>
            <td>{{ fee.price | smartNumber }}</td>
            <td>{{ getAdditionalFeeUom(fee.id) }}</td>
            <td>{{ fee.usdT }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Section 4: Remarks -->
  <div class="section">
    <div class="section-header">Remarks</div>
    <mat-form-field appearance="outline" class="form-field">
      <textarea
        matInput
        class="disabled"
        readonly
        placeholder="Additional remarks"
        >{{ data.remarks || "Additional remarks" }}</textarea
      >
    </mat-form-field>
  </div>

  <!-- Section: Attachments -->
  <div class="section">
    <div class="section-header">Attachments</div>
    <mat-list class="attached-files">
        <mat-list-item *ngFor="let attachment of attachments">
          <div class="mat-list-item-row">
            <div
              class="mat-list-item-title"
              (click)="downloadAttachment(attachment.id)"
            >
              {{ attachment.originalFileName }}
            </div>
            <button
              mat-icon-button
              type="button"
              (click)="removeAttachment(attachment)"
              [disabled]="downloadingFile"
            >
              <mat-icon matListItemIcon>delete</mat-icon>
            </button>
          </div>
        </mat-list-item>
      </mat-list>
  </div>
</mat-dialog-content>
